export function taskTemplatesPath(site) {
  return 'task_templates';
}

export function tasksPath(site) {
  return [site, 'task_data', 'tasks'].join('/');
}

export function stepsPath(site) {
  return [site, 'task_data', 'steps'].join('/');
}

export function argumentTypesPath(site, argType) {
  return [site, 'argument_types', argType].join('/');
}

export function robotsPath(site, robotId) {
  return [site, 'robots', robotId].join('/');
}

export const robotLocktubePath = (site, robotId) => [site, 'robots', robotId, 'locktube'].join('/');

export const TaskAttributes = {
  UUID: 'uuid',
  REQUESTED_BY: 'requested_by',
  CLAIMED_BY: 'claimed_by',
  CREATED: 'created',
  TASK_TYPE: 'task_type',
  TASK_ARGS: 'task_level_args',
  TASK_DATA: 'task_data',
  STATUS: 'status',
  RESULT: 'result',
  RESULT_CONFIRMATION_STATUS: 'result_confirmation_status',
  STEPS: 'steps',
  NUMBER_IN_QUEUE: 'number_in_queue',
};

export const TaskStatus = {
  REQUEST: 'request',   //NB: while tube/drawer statuses are "requested", task statuses are "request"
  REQUEST_CANCELED: 'request_canceled',
  AUTO_REQUEST_CANCELED: 'auto_request_canceled',
  TODO: 'todo',
  IN_PROGRESS: 'in_progress',
  CLAIMED: 'claimed',
  DONE: 'done',
  CONCLUDED: 'concluded',
  CANCEL: 'cancel',
};

export const TaskResultConfirmationStatus = {
  UNCONFIRMED: 'unconfirmed',
  CONFIRMED: 'confirmed',
  AUTO_CONFIRMED: 'auto_confirmed',
};

export const RobotAttributes = {
  CURRENT_TASK: 'current_task',
  LOCATION_ID: 'location_id',
  SEMANTIC_ROOM: 'semantic_room',
  TASK_STATUS: 'task_status',
  ACCEPTING_TASKS: 'accepting_tasks',
};

export const RobotTaskStatus = {
  OFFLINE: 'OFFLINE',
  IDLE: 'IDLE',
  BUSY: 'BUSY',
  FAILED: 'FAILED',
  RESUME: 'RESUME',
};
